import { useChatsModel } from '@models/Chats/ChatsModel';
import { ToastService } from '@services';
import { parseApiError } from '@utils';

export function useChats() {
  const chats = useChatsModel();

  async function fetch() {
    try {
      await chats.list.fetch.run();
    } catch (error) {
      ToastService.showError(parseApiError(error).message);
    }
  }

  async function fetchMore() {
    try {
      await chats.list.fetchMore.run();
    } catch (error) {
      ToastService.showError(parseApiError(error).message);
    }
  }

  async function search() {
    if (!chats.searched.searchQuery) {
      return;
    }

    try {
      await chats.searched.fetch.run();
    } catch (error) {
      ToastService.showError(parseApiError(error).message);
    }
  }

  async function searchMore() {
    try {
      await chats.searched.fetchMore.run();
    } catch (error) {
      ToastService.showError(parseApiError(error).message);
    }
  }

  return { fetch, fetchMore, search, searchMore };
}
